import type { StepsToBusinessOwnerProps } from '../../../components/StepsToBusinessOwner/StepsToBusinessOwner';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformStepsToBusinessOwner = (data: CMSTransformerDataType): StepsToBusinessOwnerProps => {
  const stepsToBusinessOwner = Array.isArray(data.steps_to_business_owner)
    ? data.steps_to_business_owner[0]
    : data.steps_to_business_owner;
  const businessSteps = stepsToBusinessOwner.steps.map((step: CMSTransformerDataType) => ({
    description: step.description,
    image: step.image.images.map((image: CMSTransformerDataType) => ({
      url: image.image.url,
      altText: image.alt_text,
      viewport: image.viewport,
    })),
  }));
  return {
    componentType: ComponentType.steps_to_business_owner,
    title: stepsToBusinessOwner.display_title,
    link: { text: stepsToBusinessOwner.link.text, url: stepsToBusinessOwner.link.url },
    businessSteps,
  };
};

export default transformStepsToBusinessOwner;
